import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store/main';
import { Channel } from '@/types/channel.types';
import { BLAdmin } from '@/types/profile.types';
import { FeatureFlagsEnum } from '../feature-flags/types';

export const getToken = (state: RootState): string | null => state.user.idToken;
export const getGreenroomToken = (state: RootState): string | null => state.user.greenroomToken;
export const getUser = (state: RootState): BLAdmin | null => state.user.user;
export const selectUser = getUser;
export const getActiveChannel = (state: RootState): number | null => state.user?.user?.active_channel || null;
export const selectActiveChannel = getActiveChannel; // just for naming consistency
export const selectUserChannel = (state: RootState): Channel | null => {
  const activeChannel = getActiveChannel(state);
  return state.channels.channels?.find((channel) => channel.channel === activeChannel) || null;
};
export const getChangingChannels = (state: RootState): boolean => state.user.changingChannels;
export const selectChangingChannels = getChangingChannels; // just for naming consistency
export const getSigningOut = (state: RootState): boolean => state.user.signingOut;
export const getBetaFlagOptIns = (state: RootState): FeatureFlagsEnum[] | undefined => state.user?.user?.beta_opt_ins;
export const getChannelType = (state: RootState) => state.user.channelType;
export const selectUserChannelColor = createSelector(
  selectUserChannel,
  (channel) => channel?.colors?.primary || '#333333'
);
